import { z } from 'zod'

export const otpVerificationDataSchema = z.object({
  /** 帳號 */
  account: z.string(),
  /** 裝置ID */
  deviceId: z.string(),
  /** OTP驗證碼 */
  otpCode: z.string(),
  /** sseCode */
  sseCode: z.string()
})

export interface OtpVerificationData
  extends z.infer<typeof otpVerificationDataSchema> {}

export class OtpVerificationData {
  constructor() {
    return {
      account: '',
      deviceId: '',
      otpCode: '',
      sseCode: ''
    }
  }
}
